import { render, staticRenderFns } from "./StatisticsResultsBlock.vue?vue&type=template&id=77040d16"
import script from "./StatisticsResultsBlock.vue?vue&type=script&lang=js"
export * from "./StatisticsResultsBlock.vue?vue&type=script&lang=js"
import style0 from "./StatisticsResultsBlock.vue?vue&type=style&index=0&id=77040d16&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports